// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paypal-buttons {\n  display: block !important;\n}\n.message {\n  margin: 10vh auto;\n  text-align: center;\n  max-width: 90%;\n  color: #6a6d82;\n}", ""]);
// Exports
module.exports = exports;
